import React from 'react'
import { Modal, Frame } from '@react95/core'
import { Box, Heading, Text } from '@pancakeswap/uikit'
import { Gcdef100, Progman21 } from '@react95/icons'
import { useTranslation } from 'contexts/Localization'
import { useTokenBalances } from 'state/wallet/hooks'
import { TokenAmount } from '@pancakeswap/sdk'
import tokens from 'config/constants/tokens'
import { useWeb3React } from '@web3-react/core'
import ConnectWalletButton from 'components/ConnectWalletButton'
import { Link } from 'react-router-dom'

const GamesModal = ({ close, modalStyle, frameStyle }) => {
  const { t } = useTranslation()
  const { account } = useWeb3React()
  const balances = useTokenBalances(account, [tokens.bnb, tokens.busd, tokens.windoge95])
  const windogeBalance: undefined | TokenAmount = balances?.[tokens.windoge95.address]
  const iconStyle: any = { height: '52px', width: '52px' }
  return (
    <Modal
      defaultPosition={{ x: 12, y: 12 }}
      icon={<Progman21 />}
      title="Games"
      closeModal={close}
      width="90vw"
      height="90vh"
      style={modalStyle}
      buttons={[{ value: 'Ok', onClick: close }]}
    >
      <Frame style={frameStyle}>
        <Heading scale="xl" mb="16px" mt="16px">
          {t(`Games`)}
        </Heading>
        <Text fontSize="18px" mb="24px">
          {t(`In order to play games on Windoge95, you must hold at least 10,000 V1 tokens.`)}
        </Text>
        {!account && <ConnectWalletButton />}

        {!windogeBalance ||
          (Number.parseFloat(windogeBalance?.toFixed(9)) < 10000 && (
            <Text fontWeight="bold" color="#B62323" fontSize="18px" mb="24px">
              {t(
                `You do not have enough Windoge to access the Arcade. Please visit the swap to buy some Windoge tokens.`,
              )}
            </Text>
          ))}

        {account && (
          <>
            <Text fontSize="24px" fontWeight="bold">
              {t(`Your Windoge Balance:`)}
            </Text>
            <Text fontSize="24px" fontWeight="bold">
              {windogeBalance?.toFixed(2) || 'Loading balance...'} WNDG
            </Text>
          </>
        )}
        {windogeBalance && Number.parseFloat(windogeBalance?.toFixed(9)) >= 10000 && (
          <>
            <Text color="black" fontSize="20px" my="24px" textAlign="left">
              {t('You have enough Windoge to access the arcade! Click the launch icon to get started!')}
            </Text>
            <Link to="/arcade">
              <Box
                style={{
                  width: '154px',
                  textAlign: 'center',
                  marginLeft: '16px',
                  marginTop: '16px',
                  marginBottom: '16px',
                  cursor: 'pointer',
                }}
              >
                <Gcdef100 style={iconStyle} />
                <Text color="black" fontSize="20px" textAlign="center">
                  {t('Launch Arcade')}
                </Text>
              </Box>
            </Link>
          </>
        )}
      </Frame>
    </Modal>
  )
}

export default GamesModal
